// extracted by mini-css-extract-plugin
module.exports = {"popup-container-class":"search_popup-container-class__27wQT","popup-content-title":"search_popup-content-title__1XZ2L"};